const API_ROOT = "https://app247.azurewebsites.net/api";
//const API_ROOT ="http://localhost:5147/api";
const API_BASE = `${API_ROOT}/ResonanceBioBankWeb`;

function withAuthFetch(url, options = {}) {
  return fetch(url, {
    credentials: "include",
    ...options,
  });
}

function escapeHtml(text) {
  if (text === null || text === undefined) return "";
  return String(text)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

export async function fetchSubmissions() {
  const resp = await withAuthFetch(`${API_BASE}/getAll`, { cache: "no-store" });
  if (!resp.ok) throw new Error(`HTTP ${resp.status} - ${resp.statusText}`);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}

export async function approveSubmission(id) {
  const resp = await withAuthFetch(`${API_BASE}/approve`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ id }),
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json().catch(() => ({}));
}

export async function submitConsent(formData, isPrint) {
  const resp = await withAuthFetch(`${API_BASE}/postResonanceBioBankWeb`, {
    method: "POST",
    body: formData,
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  if (isPrint) {
    return resp.blob();
  }
  return resp.json().catch(() => ({}));
}

export async function submitContactUs(contactData) {
  const resp = await withAuthFetch(`${API_BASE}/submit-contactus`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(contactData),
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json().catch(() => ({}));
}

export async function submitSurvey(surveyData) {
  const diagnoses = Array.isArray(surveyData?.diagnoses) ? surveyData.diagnoses : [];
  const serviceName = diagnoses.length > 0 ? diagnoses[0] : "General Survey";
  const resp = await withAuthFetch(`${API_ROOT}/SurveyData/submit`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ serviceName, surveyData }),
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json().catch(() => ({}));
}

export async function fetchSurveySubmission(id) {
  const resp = await withAuthFetch(`${API_ROOT}/SurveyData/${id}`, {
    method: "GET",
    cache: "no-store",
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}

export async function loginReactUser(username, password) {
  const resp = await withAuthFetch(`${API_ROOT}/User/loginReact`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ username, password, rememberMe: false }),
  });

  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(msg || `HTTP ${resp.status}`);
  }

  return resp.json();
}

export async function logoutReactUser() {
  const resp = await withAuthFetch(`${API_ROOT}/User/logoutReact`, {
    method: "POST",
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json().catch(() => ({}));
}

export async function fetchCurrentReactUser() {
  const resp = await withAuthFetch(`${API_ROOT}/User/currentReactUser`, {
    method: "GET",
    cache: "no-store",
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}

export async function createReactUser(payload) {
  const resp = await withAuthFetch(`${API_ROOT}/User/postReactUser`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(msg || `HTTP ${resp.status}`);
  }
  return resp.json().catch(() => ({}));
}

export async function fetchReactUsers() {
  const resp = await withAuthFetch(`${API_ROOT}/User/reactUsers`, { method: "GET" });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  return resp.json();
}

export async function changePassword(currentPassword, newPassword) {
  const resp = await withAuthFetch(`${API_ROOT}/User/changePassword`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ currentPassword, newPassword }),
  });
  if (!resp.ok) {
    const msg = await resp.text();
    throw new Error(msg || `HTTP ${resp.status}`);
  }
  return resp.json().catch(() => ({}));
}

export async function fetchSurveyServices(serviceName, searchText) {
  const params = new URLSearchParams();
  if (serviceName) params.append("serviceName", serviceName);
  if (searchText) params.append("searchText", searchText);

  const resp = await withAuthFetch(`${API_ROOT}/SurveyData/services?${params.toString()}`, {
    method: "GET",
    cache: "no-store",
  });
  if (!resp.ok) throw new Error(`HTTP ${resp.status}`);
  const data = await resp.json();
  return Array.isArray(data) ? data : [];
}

export async function fetchConsentText(lang) {
  let path = "/assets/Informed_Consent_English_ch.txt";
  if (lang === "hi") path = "/assets/Informed_Consent_Hindi_ch.txt";
  if (lang === "te") path = "/assets/Informed_Consent_Telugu_ch.txt";
  const resp = await fetch(process.env.PUBLIC_URL + path, { cache: "no-store" });
  if (!resp.ok) throw new Error("Not found");
  return resp.text();
}

export { escapeHtml };
